/* eslint-disable max-lines-per-function */
import apiUser from '@/api/user';
import apiSubscription from '@/api/subscription';
import { actions, mutations } from './user.d';

export default {
  /**
   * Initialize Current Concierge
   */
  [actions.getUser]: async function({ commit, dispatch }, userId) {
    dispatch('loading/start', 'user.getUser', { root: true });
    const user = await apiUser.getUser(userId);
    dispatch(actions.checkUserSubscription, userId);
    dispatch('loading/end', 'user.getUser', { root: true });

    commit(mutations.setCurrentUserPremium, false);
    return commit(mutations.setCurrentUser, user);
  },

  /**
   * Initialize Current Concierge
   */
  [actions.searchUser]: async function({ dispatch }, keyword) {
    dispatch('loading/start', 'user.searchUser', { root: true });
    const searchResult = await apiUser.searchUser(keyword);
    dispatch('loading/end', 'user.searchUser', { root: true });
    return searchResult;
  },
  [actions.checkUserSubscription]: async function({ commit }, userId) {
    const subscriptions = await apiSubscription.getSubscriptionByUserId(userId);
    if (subscriptions.length === 0) {
      commit(mutations.setCurrentUserPremium, false);
      return commit(mutations.setCurrentUserPremiumExpiryDate, 0);
    }

    // Find the user's active subscription
    const nowInMilliseconds = Date.now();
    const activeSubscription = subscriptions.filter(
      ({ expirationDateTime }) => {
        const isNotExpired = expirationDateTime > nowInMilliseconds;
        return isNotExpired;
      }
    );

    const latestExpirationDateTime = subscriptions.sort(
      ({ expirationDateTime }, { expirationDateTime: expirationDateTime2 }) => {
        return expirationDateTime2 - expirationDateTime;
      }
    )[0].expirationDateTime;

    if (!activeSubscription || !activeSubscription.length) return false;
    commit(mutations.setCurrentUserPremiumExpiryDate, latestExpirationDateTime);
    return commit(mutations.setCurrentUserPremium, true);
  }
};
